// tslint:disable
import { Component, Injector } from "@angular/core";

import { CMFormComponent } from "../../@cmcore/component/cmform/cmform.component";

import {
  CMFormGlobaisComponent,
  CMFormModalComponent,
  CMGridEditConfig,
  CMInputConfig,
  CMGridEditConfigColumn,
  CMGridEditConfigMore,
  CMINPUT_CONTROL_VALUE_ACCESSOR,
} from "../../@cmcore/component";
import {
    NFeBrowseComponent, ProdutoBrowseComponent,
} from "../index";
import { FuncsGlobais } from "../funcs.globais";
@Component({
  selector: "nfe-gerar-saida-estoque",
  templateUrl: "nfe-gerar-saida-estoque.component.html",
  styleUrls: ["nfe-gerar-saida-estoque.component.scss"],
})
export class NFeGerarSaidaEstoqueComponent extends CMFormComponent {
  
  public filter: any = {};
  private innerFilterConfig = {};
  public get filterConfig() {
    return this.innerFilterConfig;
  }
  public set filterConfig(value: any) {
    this.innerFilterConfig = value;
    this.filter = {};
    this.generateEmptyModel(value, this.filter);
  }
  
  valid() {
    return super.valid(this.filterConfig, this.filter);
	}

  _owner: NFeBrowseComponent = undefined;
  
  setFilterConfig(){
    this.filterConfig = {
      
      historico: new CMGridEditConfig({
        caption: "Histórico de Saídas Anteriores",
        form: NFeGerarSaidaEstoqueComponent,
        onRemoveItem: (item) => {
          this.postDeleteSaidaEstoque(item);
          console.log(this._owner.grid.fieldByName(this.owner.fieldNameId()));
        },
        fields: {
          produto: new CMInputConfig({
            form: this,
            caption: "Produto",
            disabled: true,
            maxlength: 30,
            padInfo: { size: 30 },
            gridConfig: new CMGridEditConfigColumn({
              tipo: "input-pesquisa",
              getValue: (row) => {
                return this.getValueObject(row, "produto.codigo");
              },
              getBottomLabelColumn: (row) => {
                return this.getValueObject(row, "produto.descr");
              },
            }),
          }),
          quantidade: new CMInputConfig({
            form: this,
            caption: "Quantidade",
            dataType: "double(2)",
            disabled: true,
            gridConfig: new CMGridEditConfigColumn(),
            hintButton: "Editar",
            iconButton: () => {
              if (this.disabledAll) return "visibility";
              else return "edit";
            },
            showButtonClear: false,
            pesqOnlyFunc: (row) => this.mostraDetalhesQuantidade(row),
            pesqFunc: (sender) => {
              if (this.mostraDetalhesQuantidade(this.filterConfig.historico.current)){

                this.postSubscribe(
                  '/api/saidaestoque/GetSaidasEstoqueDetalhe',
                  JSON.stringify({
                    idnfe: this._owner.grid.fieldByName(this.owner.fieldNameId()),
                    idproduto: this.filterConfig.historico.current.produto.id,
                    datasaida: this.filterConfig.historico.current.datasaida
                  }),
                  (result: any) => {
                    this.filterConfig.historico.current.estoque = result;
          
                    console.log('this.dados.historico: ', this.dados.historico);
                    console.log('result: ', result);
                  },
                  error => {
                    CMFormGlobaisComponent.hideSpinner();
                    this.showMessageErrorHTTP('GetSaidasEstoque', error);
                  }
                )

                this.filterConfig.historico.extraClick(
                  new CMGridEditConfigMore({
                    index: 0,
                    title: "Detalhes da Quantidade",
                  })
                );
              }
              setTimeout(() => {
                document.querySelector("[id^='extra_grid_']").parentNode.lastChild.remove();
              }, 1500)
            },
            showButtonFunc: (show, row) => this.mostraDetalhesQuantidade(row),
          }),
          datasaida: new CMInputConfig({
            form: this,
            disabled: true,
            caption: "Data da Saída",
            gridConfig: new CMGridEditConfigColumn(),
          }),
          estoque: new CMGridEditConfig({
            form: this,
            required: false,
            fields: {
              grade: new CMInputConfig({
                form: this,
                caption: "Grade",
                disabled: true,
                pesqOnly: true,
                gridConfig: new CMGridEditConfigColumn({
                  tipo: "input-pesquisa",
                  getValue: (row) => {
                    return this.getValueObject(row, "grade.descricao");
                  },
                }),
                visibleFunc: () => {
                  return this.currentProdutoUsaGrade();
                },
              }),
              numerolote: new CMInputConfig({
                form: this,
                caption: "Número Lote",
                dataType: "string",
                maxlength: 20,
                gridConfig: new CMGridEditConfigColumn({
                  tipo: "input-pesquisa",
                  disabledFunc: (row) => {
                    if (this.currentProdutoUsaGrade())
                      return this.getValueObject(row, "grade.id") === "";
                    else return false;
                  },
                  getValue: (row) => {
                    return this.getValueObject(row, "numerolote");
                  },
                }),
                pesqFunc: (sender) => {
                  ProdutoBrowseComponent.pesquisaLote(
                    sender,
                    this.filterConfig.historico.fields.estoque.current,
                    this.filterConfig.historico.current.produto.id,
                    this.filterConfig.historico.fields.estoque.current.grade.id
                  );
                },
                requiredFunc: () => {
                  return this.currentProdutoUsaLote();
                },
                visibleFunc: () => {
                  return this.currentProdutoUsaLote();
                },
              }),
              datavalidadelote: new CMInputConfig({
                form: this,
                caption: "Data Validade Lote",
                mask: "99/99/9999",
                disabled: true,
                gridConfig: new CMGridEditConfigColumn(),
                requiredFunc: () => {
                  return this.currentProdutoUsaValidadeLote();
                },
                visibleFunc: () => {
                  return this.currentProdutoUsaValidadeLote();
                },
              }),
              qcom: new CMInputConfig({
                form: this,
                disabled: true,
                caption: "Quantidade",
                dataType: "double(2)",
                gridConfig: new CMGridEditConfigColumn(),
                disabledFunc: () => {
                  return this.date !== this.filterConfig.historico.current.datasaida;
                },
                /*
                onKeyPress: (row) => {
                  console.log('changed: ');
                  let item = this.filterConfig.itens.current;

                  item.estoquesaida.forEach((est) => {
                    est.qcom = 0;
                  });
                  item.quantidadesaida = 0;
                },*/
              }),
            },
          }),
        }
      }),
      itens: new CMGridEditConfig({
        caption: "Saldo de Produto à Entregar",
        form: NFeGerarSaidaEstoqueComponent,
        fields: {
          prod: {
            produto: new CMInputConfig({
              form: this,
              caption: "Produto",
              disabled: true,
              maxlength: 30,
              padInfo: { size: 30 },
              gridConfig: new CMGridEditConfigColumn({
                tipo: "input-pesquisa",
                getValue: (row) => {
                  return this.getValueObject(row, "prod.produto.codigo");
                },
                getBottomLabelColumn: (row) => {
                  return this.getValueObject(row, "prod.produto.descr");
                },
              }),
            }),
            qcom: new CMInputConfig({
              form: this,
              caption: "Quantidade",
              dataType: "double(2)",
              disabled: true,
              gridConfig: new CMGridEditConfigColumn(),
              hintButton: "Editar",
              iconButton: () => {
                if (this.disabledAll) return "visibility";
                else return "edit";
              },
              showButtonClear: false,
              pesqOnlyFunc: (row) => this.mostraDetalhesQuantidade(row),
              pesqFunc: (sender) => {
                if (this.mostraDetalhesQuantidade(this.filterConfig.itens.current))
                  this.filterConfig.itens.extraClick(
                    new CMGridEditConfigMore({
                      index: 0,
                      title: "Detalhes da Quantidade",
                    })
                  );
                setTimeout(() => {
                  document.querySelector("[id^='extra_grid_']").parentNode.lastChild.remove();
                }, 1500)
              },
              showButtonFunc: (show, row) => this.mostraDetalhesQuantidade(row),
            }),
            quantidadeentregue: new CMInputConfig({
              form: this,
              caption: "Quantidade Entregue",
              dataType: "double(2)",
              disabled: true,
              gridConfig: new CMGridEditConfigColumn(),
              hintButton: "Editar",
              iconButton: () => {
                if (this.disabledAll) return "visibility";
                else return "edit";
              },
              showButtonClear: false,
              pesqOnlyFunc: (row) => this.mostraDetalhesQuantidade(row),
              pesqFunc: (sender) => {
                if (this.mostraDetalhesQuantidade(this.filterConfig.itens.current)){
                  this.filterConfig.itens.extraClick(
                    new CMGridEditConfigMore({
                      index: 2,
                      title: "Detalhes da Quantidade",
                    })
                  );
                  setTimeout(() => {
                    document.querySelector("[id^='extra_grid_']").parentNode.lastChild.remove();
                  }, 1500)
                }
              },
              showButtonFunc: (show, row) => this.mostraDetalhesQuantidade(row),
            }),
            /*
            datasaida: new CMInputConfig({
              form: this,
              disabled: true,
              caption: "Data da Saída",
              gridConfig: new CMGridEditConfigColumn(),
            }),*/
            quantidadesaida: new CMInputConfig({
              form: this,
              caption: "Quantidade Saída",
              dataType: "double(2)",
              gridConfig: new CMGridEditConfigColumn(),
              hintButton: "Editar",
              iconButton: () => {
                if (this.disabledAll) return "visibility";
                else return "edit";
              },
              showButtonClear: false,
              pesqOnlyFunc: (row) => this.mostraDetalhesQuantidade(row),
              pesqFunc: (sender) => {
                if (this.mostraDetalhesQuantidade(this.filterConfig.itens.current)){
                  this.filterConfig.itens.extraClick(
                    new CMGridEditConfigMore({
                      index: 1,
                      title: "Detalhes da Quantidade",
                    })
                  );
                  setTimeout(() => {
                    document.querySelector("[id^='extra_grid_']").parentNode.lastChild.remove();
                  }, 1500)
                }
              },
              showButtonFunc: (show, row) => this.mostraDetalhesQuantidade(row),
              onExit: () => {
                if (!this.currentProdutoUsaGrade() && !this.currentProdutoUsaLote()) {
                  this.filterConfig.itens.current.estoquesaida[0].qcom = this.filterConfig.itens.current.quantidadesaida;
                }
              }
            }),

          },
          estoque: new CMGridEditConfig({
            form: this,
            required: false,
            fields: {
              grade: new CMInputConfig({
                form: this,
                caption: "Grade",
                disabled: true,
                pesqOnly: true,
                gridConfig: new CMGridEditConfigColumn({
                  tipo: "input-pesquisa",
                  getValue: (row) => {
                    return this.getValueObject(row, "grade.descricao");
                  },
                }),
                visibleFunc: () => {
                  return this.currentProdutoUsaGrade();
                },
              }),
              numerolote: new CMInputConfig({
                form: this,
                caption: "Número Lote",
                dataType: "string",
                maxlength: 20,
                disabled: true,
                gridConfig: new CMGridEditConfigColumn({
                  tipo: "input-pesquisa",
                  disabledFunc: (row) => {
                    if (this.currentProdutoUsaGrade())
                      return this.getValueObject(row, "grade.id") === "";
                    else return false;
                  },
                  getValue: (row) => {
                    return this.getValueObject(row, "numerolote");
                  },
                }),
                pesqFunc: (sender) => {
                  ProdutoBrowseComponent.pesquisaLote(
                    sender,
                    this.filterConfig.itens.fields.estoque.current,
                    this.filterConfig.itens.current.produto.id,
                    this.filterConfig.itens.fields.estoque.current.grade.id
                  );
                },
                requiredFunc: () => {
                  return this.currentProdutoUsaLote();
                },
                visibleFunc: () => {
                  return this.currentProdutoUsaLote();
                },
              }),
              datavalidadelote: new CMInputConfig({
                form: this,
                caption: "Data Validade Lote",
                mask: "99/99/9999",
                disabled: true,
                gridConfig: new CMGridEditConfigColumn(),
                requiredFunc: () => {
                  return this.currentProdutoUsaValidadeLote();
                },
                visibleFunc: () => {
                  return this.currentProdutoUsaValidadeLote();
                },
              }),
              qcom: new CMInputConfig({
                form: this,
                disabled: true,
                caption: "Quantidade",
                dataType: "double(2)",
                gridConfig: new CMGridEditConfigColumn(),
              }),
            },
          }),
          estoquesaida: new CMGridEditConfig({
            form: this,
            required: false,
            fields: {
              grade: new CMInputConfig({
                form: this,
                caption: "Grade",
                disabled: true,
                pesqOnly: true,
                gridConfig: new CMGridEditConfigColumn({
                  tipo: "input-pesquisa",
                  getValue: (row) => {
                    return this.getValueObject(row, "grade.descricao");
                  },
                }),
                visibleFunc: () => {
                  return this.currentProdutoUsaGrade();
                },
              }),
              numerolote: new CMInputConfig({
                form: this,
                caption: "Número Lote",
                dataType: "string",
                maxlength: 20,
                disabled: true,
                gridConfig: new CMGridEditConfigColumn({
                  tipo: "input-pesquisa",
                  disabledFunc: (row) => {
                    if (this.currentProdutoUsaGrade())
                      return this.getValueObject(row, "grade.id") === "";
                    else return false;
                  },
                  getValue: (row) => {
                    return this.getValueObject(row, "numerolote");
                  },
                }),
                pesqFunc: (sender) => {
                  ProdutoBrowseComponent.pesquisaLote(
                    sender,
                    this.filterConfig.itens.fields.estoquesaida.current,
                    this.filterConfig.itens.current.produto.id,
                    this.filterConfig.itens.fields.estoquesaida.current.grade.id
                  );
                },
                requiredFunc: () => {
                  return this.currentProdutoUsaLote();
                },
                visibleFunc: () => {
                  return this.currentProdutoUsaLote();
                },
              }),
              datavalidadelote: new CMInputConfig({
                form: this,
                caption: "Data Validade Lote",
                mask: "99/99/9999",
                disabled: true,
                gridConfig: new CMGridEditConfigColumn(),
                requiredFunc: () => {
                  return this.currentProdutoUsaValidadeLote();
                },
                visibleFunc: () => {
                  return this.currentProdutoUsaValidadeLote();
                },
              }),
              qcom: new CMInputConfig({
                form: this,
                disabled: false,
                caption: "Quantidade",
                dataType: "double(2)",
                gridConfig: new CMGridEditConfigColumn(),
                onExit: () => {
                  this.calcTotalItemEstoque();
                },
              }),
            },
          }),
          estoqueentregue: new CMGridEditConfig({
            form: this,
            required: false,
            onGetValue: () => {
              console.log("onGetValue");
            },
            fields: {
              grade: new CMInputConfig({
                form: this,
                caption: "Grade",
                pesqOnly: true,
                gridConfig: new CMGridEditConfigColumn({
                  tipo: "input-pesquisa",
                  getValue: (row) => {
                    return this.getValueObject(row, "grade.descricao");
                  },
                }),
                visibleFunc: () => {
                  return this.currentProdutoUsaGrade();
                }
              }),
              numerolote: new CMInputConfig({
                form: this,
                caption: "Número Lote",
                dataType: "string",
                maxlength: 20,
                disabled: true,
                gridConfig: new CMGridEditConfigColumn({
                  tipo: "input-pesquisa",
                  disabledFunc: (row) => {
                    if (this.currentProdutoUsaGrade())
                      return this.getValueObject(row, "grade.id") === "";
                    else return false;
                  },
                  getValue: (row) => {
                    return this.getValueObject(row, "numerolote");
                  },
                }),
                pesqFunc: (sender) => {
                  ProdutoBrowseComponent.pesquisaLote(
                    sender,
                    this.filterConfig.itens.fields.estoqueentregue.current,
                    this.filterConfig.itens.current.produto.id,
                    this.filterConfig.itens.fields.estoqueentregue.current.grade.id
                  );
                },
                requiredFunc: () => {
                  return this.currentProdutoUsaLote();
                },
                visibleFunc: () => {
                  return this.currentProdutoUsaLote();
                },
              }),
              datavalidadelote: new CMInputConfig({
                form: this,
                caption: "Data Validade Lote",
                mask: "99/99/9999",
                disabled: true,
                gridConfig: new CMGridEditConfigColumn(),
                requiredFunc: () => {
                  return this.currentProdutoUsaValidadeLote();
                },
                visibleFunc: () => {
                  return this.currentProdutoUsaValidadeLote();
                },
              }),
              quantidadeentregue: new CMInputConfig({
                form: this,
                disabled: true,
                caption: "Quantidade",
                dataType: "double(2)",
                gridConfig: new CMGridEditConfigColumn(),
                /*
                onKeyPress: (row) => {
                  console.log('changed: ');
                  let item = this.filterConfig.itens.current;

                  item.estoquesaida.forEach((est) => {
                    est.qcom = 0;
                  });
                  item.quantidadesaida = 0;
                },
                disabledFunc: () => {
                  return this.filterConfig.itens.current.datasaida !== this.filterConfig.historico.current.datasaida;
                }*/
              }),
            },
          }),
        }
      })
    }
  }


  postDeleteSaidaEstoque(item: any) {
    console.log("item a ser excluído: ", item);
    
    //let itemsaidaX = this.dados.produtos.find(itemnfe => itemnfe.id === itemsaida.id);
    //itemsaidaX = null;
    CMFormGlobaisComponent.showSpinner();
    this.postSubscribe(
      "/api/saidaestoque/DeleteSaidaEstoque",
      JSON.stringify({
        idnfe: this._owner.grid.fieldByName(this.owner.fieldNameId()),
        data: item.datasaida,
        idproduto: item.produto.id
      }),
      (res) => {
        if (res["result"] == "ok") {

          console.log("item: ", item);
          console.log("this.dados.produtos: ", this.dados.produtos);

          let itemsaida = this.dados.produtos.find(itemnfe => itemnfe.id === item.id);

          console.log("itemsaida: ", itemsaida);
      
          let qtdtemp = itemsaida.prod.quantidadeentregue;
      
          itemsaida.prod.quantidadeentregue = itemsaida.prod.quantidadesaida;
          itemsaida.prod.quantidadesaida = qtdtemp;
      
          let estoquetemp = itemsaida.prod.estoqueentregue;
      
          itemsaida.prod.estoqueentregue = itemsaida.prod.estoquesaida;
          itemsaida.prod.estoquesaida = estoquetemp;
        }
        CMFormGlobaisComponent.hideSpinner();
      },
      (error) => {
        this.showMessageErrorHTTP("postDeleteAnotacao", error);
        CMFormGlobaisComponent.hideSpinner();
      }
    );
  }
  

  currentProdutoUsaValidadeLote() {
    return (
      this.getValueObject(
        this.filterConfig.itens.current,
        "produto.usavalidadelote"
      ) === "Sim")
  }

  dados = {
    produtos: [],
    historico: [],
  };
  
  currentProdutoUsaLote() {
    return (
      this.getValueObject(this.filterConfig.itens.current, "produto.usalote") ===
      "Sim"
    );
  }

  calcTotalItemEstoque() {

    let item = this.filterConfig.itens.current;
    
    let qtotal = 0;

    item.estoquesaida.forEach((est) => {
      qtotal += this.valueToFloat(est.qcom);
    });
    item.quantidadesaida = this.floatToValue(qtotal);
  }

  currentProdutoUsaGrade() {
    return (
      this.getValueObject(
        this.filterConfig.itens.current,
        "produto.usagrade1"
      ) === "Sim" ||
      this.getValueObject(
        this.filterConfig.itens.current,
        "produto.usagrade2"
      ) === "Sim"
    );
  }

  mostraDetalhesQuantidade(row) {
    let r = false;
    if (row && row.produto) {
      r =
        row.produto.usagrade1 === "Sim" ||
        row.produto.usagrade2 === "Sim" ||
        row.produto.usalote   === "Sim";
    }
    return r;
  }

  get owner() {
    return this._owner;
  }

  set owner(value) {
    this._owner = value;
    if (this._owner !== undefined) {

      this.getObjectData('nfe',
      [
        {'field': 'empresa', 'value': this.paramEmpresa.idEmpresa},
        {'field': 'id', 'value': this._owner.grid.fieldByName(this.owner.fieldNameId())},
      ],
      object => {
        
        console.log('Object: ', object);

        object.infnfe.det.forEach((item) => {
          item.prod.datasaida = CMFormComponent.date();
          item.estoquesaida = $.extend( true, [], item.estoque );
          item.estoqueentregue = item.estoque;

          let qtotal = 0;
          item.estoquesaida.forEach((est) => {
            qtotal += this.valueToFloat(est.quantidadeentregue);
            //console.log('est.quantidadesaida: ', est.qcom);
            est.qcom = this.floatToValue(this.valueToFloat(est.qcom) - this.valueToFloat(est.quantidadeentregue));
          });

          console.log("item.estoquesaida: ", item.estoquesaida);

          item.prod.quantidadesaida = this.floatToValue(this.valueToFloat(item.prod.qcom)-this.valueToFloat(qtotal));
          
          item.prod.quantidadeentregue = this.floatToValue(qtotal);

        });

				this.dados.produtos = object.infnfe.det;
        //this.dados.historico = object.itens;

        console.log('dadosprodutos: ', this.dados.produtos);

      });

      this.postSubscribe(
        '/api/saidaestoque/GetSaidasEstoque',
        JSON.stringify({idnfe: this.valueToInteger(this._owner.grid.fieldByName(this.owner.fieldNameId()))}),
        (result: any) => {
          this.dados.historico = result;

          console.log('this.dados.historico: ', this.dados.historico);
          console.log('result: ', result);
        },
        error => {
          CMFormGlobaisComponent.hideSpinner();
          this.showMessageErrorHTTP('GetSaidasEstoque', error);
        }
      )

    }
  }
  
  get paramEmpresa() {
    return FuncsGlobais.paramEmpresa;
  }

  constructor(_injector: Injector) {
    super(_injector);

    this.setFilterConfig();
  }

  close(formName) {
    if (this.owner) this.owner.beforeComponent = undefined;
    CMFormModalComponent.close(formName);
  }


  produtoUsaGrade(item) {
    return (
      this.getValueObject(
        item,
        "produto.usagrade1"
      ) === "Sim" ||
      this.getValueObject(
        item,
        "produto.usagrade2"
      ) === "Sim"
    );
  }

  produtoUsaLote(item) {
    return (
      this.getValueObject(
        item,
        "produto.usalote"
      ) === "Sim"
    );
  }

  gerarSaidaEstoque() {
    
    let nfeitemestoque = [];
    let itemscomerro = [];
    let estoquebaixado = true;
    let idnfe = 0;

    console.log('post dados.produtos: ', this.dados.produtos);

    this.dados.produtos.forEach((item) => {

      CMFormGlobaisComponent.showSpinner();
      
      console.log("item.estoquesaida[i]: ", item.estoquesaida);
      console.log("!this.produtoUsaGrade(item.prod): ", !this.produtoUsaGrade(item.prod));
      console.log("item: ", item);
      console.log("item.estoquesaida.length: ", item.estoquesaida.length);

      for (let i=0; i < item.estoquesaida.length; i++) {

        console.log('item.estoquesaida[i]: ', item.estoquesaida[i]);
        console.log('item.estoquesaida[i]: ', item.estoque[i]);
        console.log('item.estoquesaida[i]: ', item.estoqueentregue[i]);
        console.log('item.quantidaderestante: ', this.valueToFloat(item.estoque[i].qcom) - this.valueToFloat(item.estoque[i].quantidadeentregue));

        if (estoquebaixado && (this.valueToFloat(item.estoquesaida[i].qcom) 
            !== this.valueToFloat(item.estoque[i].qcom) - this.valueToFloat(item.estoque[i].quantidadeentregue))){
          estoquebaixado = false;
        }

        item.estoquesaida[i].datasaida = item.datasaida;


        if ((this.valueToFloat(item.estoquesaida[i].qcom) > 0 ) && !this.produtoUsaGrade(item.prod) && !this.produtoUsaLote(item.prod)) {
          item.estoquesaida[i].qcom = item.prod.quantidadesaida;
          nfeitemestoque.push(item.estoquesaida[i]);
        }
        else if ((this.valueToFloat(item.estoquesaida[i].qcom) > 0 ) && this.produtoUsaGrade(item.prod) ){
          nfeitemestoque.push(item.estoquesaida[i]);
        }
        else if ((this.valueToFloat(item.estoquesaida[i].qcom) > 0 ) && this.produtoUsaLote(item.prod) && !this.produtoUsaGrade(item.prod) ){
          nfeitemestoque.push(item.estoquesaida[i]);
        }
      }

      console.log('nfeitemestoque: ', nfeitemestoque);
      console.log('estoquebaixado: ', estoquebaixado);

      idnfe = this.valueToInteger(this._owner.grid.fieldByName(this.owner.fieldNameId()));

      if (this.produtoUsaGrade(item)){

        for (let i=0; i < item.estoque.length-1; i++) {

          console.log('item.estoque: ', this.valueToFloat(item.estoque[i].qcom));
          console.log('item.estoquesaida: ', this.valueToFloat(item.estoquesaida[i].qcom));
          
          if (this.valueToFloat(item.estoquesaida[i].qcom) > this.valueToFloat(item.estoque[i].qcom) - this.valueToFloat(item.estoque[i].quantidadeentregue)){

            if (item.produto.usagrade1 === 'Sim' && item.produto.usagrade2 === 'Não'){
              itemscomerro.push(
                {
                  codigo: this.trimValue(item.produto.codigo), 
                  descricao: item.produto.descr,
                  grade1: item.estoque[i].grade.grade1.codigo,
                  grade2: '',
                  numerolote: '',
                  msgerro: 'A quantidade de saída do produto excede a quantidade restante à ser entregue. <br><strong>Quantidade Restante: </strong>'+
                  this.floatToValue(this.valueToFloat(item.estoque[i].qcom) - this.valueToFloat(item.estoque[i].quantidadeentregue))+'<br>'+
                  '<strong>Quantidade informada: </strong>'+item.estoquesaida[i].qcom
                });
            }
            else if (item.produto.usagrade1 === 'Não' && item.produto.usagrade2 === 'Sim'){
              itemscomerro.push(
                {
                  codigo: this.trimValue(item.produto.codigo), 
                  descricao: item.produto.descr,
                  grade1: '',
                  grade2: item.estoque[i].grade.grade2.codigo,
                  numerolote: '' ,
                  msgerro: 'A quantidade de saída do produto excede a quantidade restante à ser entregue. <br><strong>Quantidade Restante: </strong>'+
                  this.floatToValue(this.valueToFloat(item.estoque[i].qcom) - this.valueToFloat(item.estoque[i].quantidadeentregue))+'<br>'+
                  '<strong>Quantidade informada: </strong>'+item.estoquesaida[i].qcom
                });
            }
            else if (item.produto.usagrade1 === 'Sim' && item.produto.usagrade2 === 'Sim'){
              itemscomerro.push(
                {
                  codigo: this.trimValue(item.produto.codigo), 
                  descricao: item.produto.descr,
                  grade1: item.estoque[i].grade.grade1.codigo,
                  grade2: item.estoque[i].grade.grade2.codigo,
                  numerolote: '' ,
                  msgerro: 'A quantidade de saída do produto excede a quantidade restante à ser entregue. <br><strong>Quantidade Restante: </strong>'+
                  this.floatToValue(this.valueToFloat(item.estoque[i].qcom) - this.valueToFloat(item.estoque[i].quantidadeentregue))+'<br>'+
                  '<strong>Quantidade informada: </strong>'+item.estoquesaida[i].qcom
                });
            }

          }
          else if (this.valueToFloat(item.estoquesaida[i].qcom) > this.valueToFloat(item.estoque[i].qcom)) {

            console.log('item: ', item);

            if (item.produto.usagrade1 === 'Sim' && item.produto.usagrade2 === 'Não'){
              itemscomerro.push(
                {
                  codigo: this.trimValue(item.produto.codigo),
                  descricao: item.produto.descr,
                  grade1: item.estoque[i].grade.grade1.codigo,
                  grade2: '',
                  numerolote: '',
                  msgerro: 'A quantidade de saída de produto excede a quantidade do produto da pré-venda.'
                });
            }
            else if (item.produto.usagrade1 === 'Não' && item.produto.usagrade2 === 'Sim'){
              itemscomerro.push(
                {
                  codigo: this.trimValue(item.produto.codigo), 
                  descricao: item.produto.descr,
                  grade1: '',
                  grade2: item.estoque[i].grade.grade2.codigo,
                  numerolote: '' ,
                  msgerro: 'A quantidade de saída de produto excede a quantidade do produto da pré-venda.'
                });
            }
            else if (item.produto.usagrade1 === 'Sim' && item.produto.usagrade2 === 'Sim'){
              itemscomerro.push(
                {
                  codigo: this.trimValue(item.produto.codigo), 
                  descricao: item.produto.descr,
                  grade1: item.estoque[i].grade.grade1.codigo,
                  grade2: item.estoque[i].grade.grade2.codigo,
                  numerolote: '' ,
                  msgerro: 'A quantidade de saída de produto excede a quantidade do produto da pré-venda.'
                });
            }

          }
        }
        

      }
      else{

        let qtotal = 0;
        item.estoquesaida.forEach((est) => {
          qtotal += this.valueToFloat(est.quantidadeentregue);
        });

        //console.log('item: ', item);
        //console.log('item.quantidadesaida: ', item.quantidadesaida);
        //console.log('this.valueToFloat(item.quantidade)-q: ', this.valueToFloat(item.quantidade)-qtotal);
        //console.log('qtotal: ', qtotal);
      
        if (!this.produtoUsaLote(item) && this.valueToFloat(item.quantidadesaida) > this.valueToFloat(item.qcom)-this.valueToFloat(qtotal)) {
          itemscomerro.push(
            {
              codigo: this.trimValue(item.produto.codigo), 
              descricao: item.produto.descr,
              grade1: '',
              grade2: '',
              numerolote: '',
              msgerro: 'A quantidade de saída do produto excede a quantidade restante à ser entregue.'
            });
        }
        else if (!this.produtoUsaLote(item) && this.valueToFloat(item.quantidadesaida) > this.valueToFloat(item.qcom)){

          console.log("item.quantidadesaida: ", item.quantidadesaida);
          console.log("item.quantidade: ", item.qcom);

          itemscomerro.push(
            {
              codigo: this.trimValue(item.produto.codigo), 
              descricao: item.produto.descr,
              grade1: '',
              grade2: '',
              numerolote: '',
              msgerro: 'A quantidade de saída do produto excede a quantidade do produto da pré-venda.'
            });
        }
      }

      /*
      item.estoquesaida.forEach((itemestoque) => {
        itemestoque.datasaida = item.datasaida;

        if (item.produto.usagrade1 === "Não" && item.produto.usagrade2 === "Não") {
          itemestoque.quantidade = item.quantidadesaida;
          nfeitemestoque.push(itemestoque);
        }
        else if ((this.valueToFloat(itemestoque.quantidade) > 0 ) && !(item.produto.usagrade1 === "Não" && item.produto.usagrade2 === "Não") ){
            nfeitemestoque.push(itemestoque);
        }
      })*/
      
      CMFormGlobaisComponent.hideSpinner();
    })

    console.log('nfeitemestoque: ', nfeitemestoque);

    
    console.log('itemscomerro: ', itemscomerro);

    
    if (nfeitemestoque.length <= 0){
      
      CMFormGlobaisComponent.showMessageAviso(' A quantidade de saída deve ser maior que 0. ');
    }
    else if (itemscomerro.length > 0){

      let html = "<div style='margin: 1em;'>";
      itemscomerro.forEach((item) => {
        html += `<p>
                   <span><strong>Codigo: </strong>${item.codigo} </span><br>
                   <span><strong>Produto: </strong>${item.descricao} </span><br>`;
        
        if (item.grade1 !== "" && item.grade2 === ""){
          html += `
                  <span><strong>Grade: </strong>${item.grade1} </span><br>
                `
        }
        if (item.grade2 !== "" && item.grade1 === ""){
          html += `
                  <span><strong>Grade: </strong>${item.grade2} </span><br>
                `
        }
        if (item.grade2 !== "" && item.grade1 !== ""){
          html += `
                  <span><strong>Grade: </strong>${item.grade1} / ${item.grade2} </span><br>
                `
        }

        html += `<span><strong>Erro: </strong>${item.msgerro} </span><br><br>
                 </p>
                `;
      });
      html += "</div>";
      CMFormGlobaisComponent.showMessageHtml(html, "Erro ao gerar a saída de estoque de um ou mais itens");
    }
    else{
      CMFormGlobaisComponent.showSpinner();
      
      this.postSubscribe("/api/nfe/GerarSaidaEstoque/FuncaoExtra",
        JSON.stringify({idnfe, estoquebaixado, nfeitemestoque}),(ret) => {
          let produtos = [];
          if (ret["data"]) produtos = ret["data"];
          //this.filter.dados.produtos = produtos;
          this.close('formGerarSaidaEstoque')
          CMFormGlobaisComponent.hideSpinner();
          CMFormGlobaisComponent.toastSucesso("Saída gerada com sucesso.");
        },
        error => {
          CMFormGlobaisComponent.hideSpinner();
          this.showMessageErrorHTTP('gerarSaidaEstoque', error);
        }
      );
    }
  }

}
